import BR09705PDF from "../../../assets/enclosure-pdf/BR090705.pdf";
import BR100604PDF from "../../../assets/enclosure-pdf/BR100604.pdf";
import TileSaddlePdf from "../../../assets/enclosure-pdf/tile-saddle-bracket.pdf";

import ImgPlaceholder from "../../../assets/imgs/icons/image-placeholder.png";

import TileSaddle1 from "../../../assets/imgs/enclosure-photos/Tile Saddle/IMG_0532.png";
import TileSaddle2 from "../../../assets/imgs/enclosure-photos/Tile Saddle/IMG_0580.png";
import TileSaddle3 from "../../../assets/imgs/enclosure-photos/Tile Saddle/IMG_0582.png";

import Clamshell1 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-01.png";
import Clamshell2 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-02.png";
import Clamshell3 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-03.png";
import Clamshell4 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-04.png";
import Clamshell5 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-05.png";
import Clamshell6 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-06.png";
import Clamshell7 from "../../../assets/imgs/enclosure-photos/LEDPanel/led-panel-07.png";

import BR100604_1 from "../../../assets/imgs/enclosure-photos/BR100604 - _L_bracket/BR100604-01.png";
import BR100604_2 from "../../../assets/imgs/enclosure-photos/BR100604 - _L_bracket/BR100604-02.png";
import BR100604_3 from "../../../assets/imgs/enclosure-photos/BR100604 - _L_bracket/BR100604-03.png";

const clamshellBracket = {
  id: 3,
  partNum: "L8E9DP7N2L",
  dimensions: "",
  title: "LED PANEL",
  img: Clamshell2,
  pdf: BR09705PDF,
  description: "LED Panel filler description text",
  technicalSpecs: ["Dimensions: 9” x 7” x 5”", "Weight: 3.8lbs"],
  kitIncludes: [],
  kitOptions: [],
  features: [
    "consectetur adipiscing elit, sed do eiusmod tempor incididunt ",
    "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt",
    "consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit",
    "Ut enim ad minima veniam, quis nostrum exercitationem",
    "vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
  ],
  kitIncludesData: [
    { img: Clamshell2, title: "LED Panel" },
    { img: ImgPlaceholder, title: "tba" },
  ],
  imgArr: [Clamshell2, Clamshell1, Clamshell3, Clamshell4, Clamshell5, Clamshell6],
  pathname: "/AMFG-Website-products-single/L8E9DP7N2L",
};

const LEDPanels = [clamshellBracket];

export default LEDPanels;